<template>
  <div class="about">
    <h1>A site for Events that change the world.</h1>
  </div>
</template>
